import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Security, useOktaAuth, LoginCallback } from "@okta/okta-react";
import { OktaAuth } from "@okta/okta-auth-js";
import oktaConfig from "./auth/oktaConfig";
import Chat from "./components/Chat/Chat";
import * as microsoftTeams from '@microsoft/teams-js';


const oktaAuth = new OktaAuth(oktaConfig);
const ALLOWED_REDIRECT_PATHS = ["/", "/chat"];
 
const restoreOriginalUri = async (oktaAuth, originalUri) => {
  const FALLBACK = "/chat";
 
  try {
    const url = new URL(originalUri || FALLBACK, window.location.origin);
 
    if (url.origin !== window.location.origin) {
      return window.location.replace(FALLBACK);
    }

    if (!ALLOWED_REDIRECT_PATHS.includes(url.pathname)) {
      return window.location.replace(FALLBACK);
    }

    return window.location.replace(url.pathname);
  } catch (err) {
    return window.location.replace(FALLBACK);
  }
};

const Protected = ({ children }) => {
  const { authState } = useOktaAuth();
  if (!authState) return null;
  return authState.isAuthenticated ? children : <Navigate to="/" replace />;
};

const AutoLogin = () => {
  const { oktaAuth, authState } = useOktaAuth();
  useEffect(() => {
    const initTeams = async () => {
      console.log("Trying to initialise teams")
      if (microsoftTeams.app.isInitialized()) {
        console.log("App already initialised")
      }
      else {
        try {
          console.log("Teams not initialised already, trying to initialise now")
          await microsoftTeams.app.initialize();
          microsoftTeams.app.notifySuccess();
          console.log("Teams SDK initialized");
        } catch (err) {
          console.log("Running outside Teams:", err);
        }
      }
    };
    console.log("Inside useeffect")
    initTeams();
  }, []);
  useEffect(() => {
    const checkAuth = async () => {

      if (!authState) return;

      if (authState.isAuthenticated) {
        console.log("Authenticated → redirecting to /chat");
        window.location.replace("/chat");
      } else {
        console.log("Not authenticated → redirecting to Okta login");
        await oktaAuth.signInWithRedirect({ originalUri: "/chat" });
      }
    };
      checkAuth();

  }, [authState]);

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      fontSize: "18px"
    }}>
      Checking authentication...
    </div>
  );
};

export default function App() {
  return (
    <Router>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Routes>
          <Route path="/" element={<AutoLogin />} />
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="/chat" element={<Protected><Chat /></Protected>} />
        </Routes>
      </Security>
    </Router>
  );
}